import { render, staticRenderFns } from "./TransferCaseTable.vue?vue&type=template&id=4c9063e8&scoped=true&"
import script from "./TransferCaseTable.vue?vue&type=script&lang=js&"
export * from "./TransferCaseTable.vue?vue&type=script&lang=js&"
import style0 from "./TransferCaseTable.vue?vue&type=style&index=0&id=4c9063e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9063e8",
  null
  
)

export default component.exports